import { IPortalPageGroup } from 'api/digifi/los/layout/GroupsApi';
import { LayoutConfigurationEntityName } from 'enums/LayoutConfigurationEntityName';
import { LayoutConfigurationReferenceType } from 'product_modules/enums/LayoutConfigurationReferenceType';

import { createLayoutEntitiesSlice } from './createLayoutEntitiesSlice';

const {
  reducer,
} = createLayoutEntitiesSlice<
  IPortalPageGroup
>({
  referenceType: LayoutConfigurationReferenceType.PortalPage,
  layoutConfigurationEntityName: LayoutConfigurationEntityName.Group,
});

export default reducer;
